import { render } from "./Select2View.vue?vue&type=template&id=811b5358"
import script from "./Select2View.vue?vue&type=script&lang=js"
export * from "./Select2View.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rithy/Documents/code/vpos.club/vpos-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__